export default {
  SET_ACCOUNTS (state, accounts) {
    state.accounts = accounts
  },
  SET_ACCOUNT_DETAILS (state, account) {
    state.account = account
  },
  ACCOUNT_UPDATED (state, account_status) {
    state.account_status = account_status
  },

  SET_DELETED_ACCOUNT (state, account) {
    state.deletedAccount = account
  },

  SET_PIXEL_TRACKING_DETAILS (state, pixelTrackingDetails) {
    state.pixelTrackingDetails = pixelTrackingDetails
  },

  SET_TRACKING_DEBUG_KEY (state, key) {
    state.trackingDebugKey = key
  }
}
